export const areaArr = [
  {areaid:1, area:'北部'},
  {areaid:2, area:'中部'},
  {areaid:3, area:'南部'},
  {areaid:4, area:'東部'}
]
export const locationArrNorth = [
  {id: 1, location: '臺北'},
]
export const locationArrCenter = [
  {id: 1, location: '臺中'},
]
export const locationArrSouth = [
  {id: 1, location: '嘉義'},
  {id: 2, location: '高雄'},
]
export const locationArrEast = [
  {id: 1, location: '臺東'},
]
